import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useSprintWeek } from '../../../Hooks/Features/ProjectHighlight/useSprintWeek.js';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';




export const ProjectSprintWeek = () => {
	const navigate = useNavigate();
	const { dropdown, dropdownData, handleDropdownChange, html } = useSprintWeek();
	const location = useLocation().state;

	return (
		<div>
			<div className='row'> 
				<div className='col-1'>
				<Dropdown value={dropdownData} onChange={(e) => handleDropdownChange(e.value)}
					options={dropdown} optionLabel={location?.key === 's' ? 'sprint_name' : 'weekNumber'}
					placeholder={location?.key === 's' ? 'Select a Sprint' : 'Select a Week'} />
					</div>
					<div className='col-1'>
				<div style={{ position: "absolute", right: '23px' }} className='button btn-default' onClick={() => navigate("/project-highlight", {})}>
					<FontAwesomeIcon icon="fa-solid fa-arrow-left" /> Back
				</div> 
					</div>
			</div>
			<div dangerouslySetInnerHTML={{ __html: html }} />
		</div>
	);
};

export default ProjectSprintWeek;

